<mat-toolbar [ngClass]="backBtnRouteUrl || routerBackOr || smartBackButton ? 'with-back-btn':''">

  <mat-toolbar-row class="no-gutters mat-toolbar-row--one">
    <ctv-sidenav-button *ngIf='isSideNavClosed$ | async' class="mr-3 d-none d-lg-inline-block"></ctv-sidenav-button>
    <div *ngIf="backBtnRouteUrl || routerBackOr || smartBackButton" class="mat-toolbar-back" matTooltip="Back">
      <button mat-mini-fab color="accent" type="button" (click)="navigateBack()" class="mat-elevation-z0">
        <i class="fas fa-chevron-left"></i>
      </button>
    </div>

    <div *ngIf="pageTitle" class="mat-toolbar-header col">
      <span *ngIf="statusColor" class="mat-toolbar-status-circle mr-2">
          <i class="fas fa-circle" ngClass="text-{{statusColor}}"></i>
        </span>
      <span class="mat-toolbar-title">
          {{pageTitle}}
        <span *ngIf="titleDescription" class="h6 small mt-n2 text-muted mat-toolbar-subtitle">
            {{titleDescription}}
          </span>
        </span>
      <i *ngIf="titleNext" class="fa fa-chevron-right title-seperator" aria-hidden="true"></i>
      <span *ngIf="titleNext" class="mat-toolbar-title mat-toolbar-title--next">
          {{titleNext}}
        </span>
    </div>

    <div class="toolbar-info col-auto">
      <ng-content select="[toolbar-info]"></ng-content>
    </div>

    <div class="toolbar-actions col-12 mt-3 col-lg mt-lg-0">
      <ng-content select="[toolbar-actions]"></ng-content>
    </div>

    <ng-content></ng-content>

  </mat-toolbar-row>

  <!--<div class="content-wrapper" style="margin-left: auto">
    <ng-content select="[toolbar-second-row]"></ng-content>
  </div>-->

  <mat-toolbar-row *ngIf="toolbarSecondRow" class="mat-toolbar-row--two">
    <div class="d-none d-lg-flex w-100">
      <ng-container *ngTemplateOutlet="toolbarSecondRow ? toolbarSecondRow : secondRow"></ng-container>
    </div>
  </mat-toolbar-row>

</mat-toolbar>

<ng-template #secondRow></ng-template>
